import React, {useContext, useEffect, useState} from "react";
import {Button, Modal, Popconfirm, Table, TableProps, Tag} from "antd";
import {AuthContext} from "../../../config/AuthContext";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {ColumnsType} from "antd/es/table";
import {CiClock2} from "react-icons/ci";
import {BiCheckCircle, BiTrash} from "react-icons/bi";
import {marcarItem} from "../../../dao/MarcarItem";
import {getDubtes} from "../../../dao/GetDubtes";
import {DeleteItem} from "../../../dao/DeleteItem";
import JutgeColors from "../../../styles/JutgeColors"; // 👈 usamos los mismos colores que ChatTableModal

interface InteractionModalProps {
    modalVisible: boolean;
    setModalVisible: (visible: boolean) => void;
    selectedRecord?: any;
}

const CuaModal: React.FC<InteractionModalProps> = ({
                                                       modalVisible,
                                                       setModalVisible,
                                                       selectedRecord,
                                                   }) => {

    const {alumne, isLoggedIn} = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const {userId, user} = useContext(AuthContext);

    useEffect(() => {
        if (isLoggedIn && selectedRecord) {
            checkDades();
        }
    }, [selectedRecord]);

    async function checkDades() {
        setLoading(true);
        const dades = await getDubtes(selectedRecord.id);
        setData(dades);
        setLoading(false);
        if (dades.length === 0) {
            setModalVisible(false);
        }
    }

    async function checkMarcar(id_dubte: number) {
        setLoading(true);
        if (await marcarItem(id_dubte, selectedRecord.id)) {
            await checkDades();
        }
    }

    async function esborrar(id: number) {
        setLoading(true);
        if (await DeleteItem(id, selectedRecord.id)) {
            await checkDades();
        }
    }

    const columns: ColumnsType<any> = [
        {
            key: "nom",
            title: "Alumne",
            dataIndex: "nom",
            width: 400,
            render: (text, ele) => (
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", gap: 10}}>
                    <img
                        src={ele.avatar || "/default-avatar.png"}
                        alt="avatar"
                        className="rounded-circle img-fluid"
                        style={{width: 40, height: 40}}
                    />
                    <div style={{flex: 1, minWidth: 0}}>
                        <div style={{fontWeight: 500, marginBottom: 2}}>
                            {ele.nom + " " + ele.cognoms || "Usuari sense nom"}
                        </div>
                        {ele.atencio === null ? (
                            <Tag color={JutgeColors.colors.color3}>EN CUA</Tag>
                        ) : (
                            <Tag color={JutgeColors.colors.color1}>ATENENT</Tag>
                        )}
                    </div>
                </div>
            ),
        },
        {
            key: "actions",
            title: "Acción",
            width: 120,
            render: (_, ele) => (
                <>
                    {ele.atencio === null && (
                        <Button
                            title="Atendre"
                            icon={<CiClock2 />}
                            style={{
                                color: "white",
                                backgroundColor: JutgeColors.colors.color1,
                                borderRadius: 10,
                                marginRight: 8
                            }}
                            onClick={() => checkMarcar(ele.id)}
                        >
                            Atendre
                        </Button>
                    )}
                    {ele.atencio !== null && (
                        <Button
                            title="Resolt"
                            icon={<BiCheckCircle />}
                            style={{
                                color: "white",
                                backgroundColor: JutgeColors.colors.color4,
                                borderRadius: 10,
                                marginRight: 8
                            }}
                            onClick={() => checkMarcar(ele.id)}
                        >
                            Resolt
                        </Button>
                    )}
                </>
            ),
        },
        {
            key: "borrar",
            title: "Eliminar",
            width: 80,
            render: (_, ele) => (
                <Popconfirm
                    title="Treure de cua"
                    description="Vols treure de cua aquest alumne/a?"
                    onConfirm={() => esborrar(ele.id)}
                    icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                >
                    <Button
                        icon={<BiTrash />}
                        title="Treure de cua"
                        style={{
                            color: JutgeColors.colors.color3,
                            borderRadius: 10
                        }}
                    />
                </Popconfirm>
            ),
        },
    ];

    const tableProps: TableProps<any> = {loading};

    return (
        <Modal
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={null}
            width={800}
            title={`Cua d'ajuda - Aula ID: ${selectedRecord?.id}`}
        >
            <Table
                showHeader={false}
                size="small"
                {...tableProps}
                bordered
                columns={columns}
                dataSource={data}
                rowKey="id"
            />
        </Modal>
    );
};

export default CuaModal;
